import { LicensePage } from "@api/types/licenses";
import { useRouter } from "next/router";
import React, { FC, useState } from "react";

import Title from "@components/Title";

import Pagination from "../Pagination";
import GiftItem from "./GiftItem";

const Gifts: FC<{ page: LicensePage }> = ({ page }) => {
  const [_page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [active, setActive] = useState(-1);
  const router = useRouter();

  const onPageChange = (p) => {
    if (p !== _page) {
      router.push(`/gifts/${p}`);
      setPage(p);
    }
  };

  return (
    <>
      <div className="container">
        <div className="results-container">
          <div className="results-header">
            <div>
              <Title>My Gifts</Title>
            </div>
          </div>
          <div className="gifts-container">
            <div className="gifts-header">
              <span className="gifts-header-span">License</span>
              <span className="gifts-header-span">Email</span>
              <span className="gifts-header-span">Status</span>
              <span className="gifts-header-span">Expiration</span>
              <span className="gifts-header-span">Actions</span>
            </div>
            <ul className="gifts-results">
              {page.content.length === 0 && (
                <p>You currently do not have any gifts. Please visit the Course Catalog to purchase gifts.</p>
              )}
              {page.content.map((license) => (
                <GiftItem key={license.id} license={license} />
              ))}
            </ul>
            <Pagination
              perPage={size}
              itemCount={parseInt(page.totalElements)}
              page={_page}
              onPageChange={(p) => onPageChange(p)}
            />
          </div>
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .results-container {
          margin-top: 0;
          margin-left: 0;
          padding: 0 0 20px;
          position: relative;
          box-sizing: border-box;
          height: auto;
          vertical-align: top;
          width: 100%;
          border-left: none;
        }
        .results-header {
          display: none;
          padding-bottom: 24px;
          border-bottom: 1px solid rgb(194, 194, 194);
        }
        .gifts-container {
          margin-left: 0;
          margin-right: 0;
          padding: 0 0 20px;
          display: inline-block;
          position: relative;
          width: 100%;
          box-sizing: border-box;
          background-color: rgb(255, 255, 255);
          overflow-x: auto;
        }
        .gifts-header {
          margin-top: 30px;
          margin-left: 0;
          padding-left: 0;
          margin-right: 0;
          line-height: 46px;
          box-sizing: border-box;
          border-bottom: 1px solid rgb(194, 194, 194);
          background-color: rgb(229, 230, 230);
          text-align: center;
        }
        .gifts-header-span {
          box-sizing: border-box;
          display: inline-block;
          width: 20%;
          line-height: 26px;
          vertical-align: middle;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
        .gifts-results {
          padding-bottom: 0;
          margin: 0;
          padding-left: 0;
          box-sizing: border-box;
        }
        @media screen and (min-width: 1025px) {
          .results-container {
            padding-bottom: 0;
            margin: 30px auto;
            /*border-left: 1px solid rgb(194, 194, 194);*/
          }
          .results-header {
            display: block;
          }
        }
        @media screen and (min-width: 992px) {
          .gifts-results {
            margin-right: 0;
            margin-left: 0;
          }
        }
        @media screen and (max-width: 575px) {
          .gifts-header-span {
            width: 100%;
          }
          .gifts-header-span:not(:first-child) {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

export default Gifts;
